<div class="row breadcume ps-4" style="width: 100%">
    <div class="col-md-9">
        <div class="row">
            <div class="breadcume-item">
                <h3 style="font-size: 14px" title="Reports">
                    <span>{{ 'IDMS.REPORTS.REPORTS' | transloco }}</span>
                    <i class="fa fa-angle-right" aria-hidden="true" style="font-size: 14px; margin: 0px 5px; color: #337ab7"></i>
                </h3>
            </div>
            <div class="breadcume-item">
                <h3 style="font-size: 14px" title="Default">
                    <span>{{ 'IDMS.REPORTS.DEFAULT' | transloco }}</span>
                    <i class="fa fa-angle-right" aria-hidden="true" style="font-size: 14px; margin: 0px 5px; color: #337ab7"></i>
                </h3>
            </div>
            <div class="breadcume-item">
                <h3 style="font-size: 14px" title="{{ reportName }}">
                    <span>{{ reportName }}</span>
                </h3>
            </div>
        </div>
    </div>
</div>
<div class="report-container">
    <div class="header-content">
        <div class="content" style="width: 100%">
            <div class="custom-head">
                <a title="Back to Reports" (click)="MoveToReports()"
                    ><img src="../../../../../../../assets/media/logos/back-icon.png" alt="back-icon" class="imgReply"
                /></a>
                <h4>
                    <strong>{{ 'IDMS.REPORTS.LOGGED_IN_AS' | transloco }} :</strong> {{ accountName }}
                </h4>
                <h4>
                    <strong>{{ 'IDMS.REPORTS.ORGANIZATION' | transloco }} :</strong> {{ currentOrg }}
                </h4>
                <h4>
                    <strong>{{ 'IDMS.REPORTS.INSTANCE' | transloco }} :</strong> {{ currentInstance }}
                </h4>
            </div>
        </div>
    </div>
    <div class="row" style="position: relative; top: 56px">
        <div class="col-md-6">
            <div>
                <div class="content" style="width: 100%">
                    <div class="custom-head">
                        <h4>{{ 'IDMS.REPORTS.SUBSCRIPTIONS' | transloco }} :{{ reportName }}</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <button class="btn primary-ebtn mt-3" (click)="AddSubscription()">{{ 'IDMS.REPORTS.ADD_SUBSCRIPTION' | transloco }}</button>
        </div>
    </div>

    <div style="position: relative; top: 56px" *ngIf="enableReport">
        <div class="dx-table-wrapper">
            <dx-data-grid
                #dataGrid
                [dataSource]="customDataSource"
                [columns]="columns"
                [showBorders]="true"
                [showRowLines]="true"
                [showColumnLines]="false"
                [allowColumnResizing]="true"
                [columnWidth]="200"
                (onExporting)="onExporting($event)"
                [sorting]="'none'"
                [remoteOperations]="true"
                class="wrapped-grid"
                (onCellPrepared)="onCellPrepared($event)"
                style="width: 100%"
            >
                <dxo-scrolling></dxo-scrolling>
                <dxo-paging [pageSize]="pageSize"></dxo-paging>
                <dxo-pager [visible]="true" [displayMode]="'compact'" [showNavigationButtons]="true"></dxo-pager>
                <dxo-load-panel [enabled]="false"></dxo-load-panel>
                <div *dxTemplate="let d of 'diffCellTemplate'">
                    <ng-container>
                        <mat-icon class="font-size-16" style="margin-left: 8px; margin-right: 1px">
                            <a
                                style="cursor: pointer"
                                href="javascript:void(0)"
                                (click)="editSubscription(d)"
                                #tooltip="matTooltip"
                                matTooltip="{{ 'IDMS.REPORTS.EDIT_SUBSCRIPTION' | transloco }}"
                                [matTooltipPosition]="tooltip_position"
                                >edit</a
                            >
                        </mat-icon>
                        <a
                            style="position: relative; top: -7px"
                            href="javascript:void(0)"
                            #tooltip="matTooltip"
                            matTooltip="{{ 'IDMS.REPORTS.SEND_REPORT_NOW' | transloco }}"
                            matTooltipPosition="above"
                            (click)="!d?.data?.schedule?.enabled ? $event.preventDefault() : sendReportNow(d)"
                            [class.disabled-link]="!d?.data?.schedule?.enabled"
                        >
                            <i class="mdi mdi-email-send"></i
                        ></a>
                        <a
                            style="position: relative; top: -7px"
                            href="javascript:void(0)"
                            #tooltip="matTooltip"
                            matTooltip="{{ 'IDMS.REPORTS.DISABLE' | transloco }}"
                            matTooltipPosition="above"
                            (click)="enableOrdDisable(d, 0)"
                            *ngIf="d?.data?.schedule?.enabled"
                        >
                            <i class="mdi mdi-email-minus"></i
                        ></a>
                        <a
                            style="position: relative; top: -7px"
                            href="javascript:void(0)"
                            #tooltip="matTooltip"
                            matTooltip="{{ 'IDMS.REPORTS.ENABLE' | transloco }}"
                            matTooltipPosition="above"
                            (click)="enableOrdDisable(d, 1)"
                            *ngIf="!d?.data?.schedule?.enabled"
                        >
                            <i class="mdi mdi-email-plus"></i
                        ></a>
                        <mat-icon
                            class="font-size-16"
                            #tooltip="matTooltip"
                            matTooltip="{{ 'IDMS.REPORTS.DELETE_SUBSCRIPTION' | transloco }}"
                            [matTooltipPosition]="tooltip_position"
                        >
                            <a href="javascript:void(0)" style="cursor: pointer" (click)="deleteSubscription(d)">delete</a>
                        </mat-icon>
                    </ng-container>
                </div>
                <div *dxTemplate="let d of 'recurrenceTypeTemplate'">
                    <ng-container *ngIf="d?.data?.schedule?.enabled">
                        {{ getRecurrenceTypeLabel(d.value) }}
                    </ng-container>
                    <ng-container *ngIf="!d?.data?.schedule?.enabled">
                        <h3 class="organization_title mt-5">
                            <span>{{ 'IDMS.REPORTS.DISABLED' | transloco }}</span>
                        </h3>
                    </ng-container>
                </div>
                <div *dxTemplate="let d of 'dateTimeTemplate'">
                    <ng-container>
                        {{ d.value | customDateTimeFormat }}
                    </ng-container>
                </div>
                <dxo-remote-operations> </dxo-remote-operations>
            </dx-data-grid>
        </div>
        <div *ngIf="SubscriptionList?.length === 0" class="d-flex align-items-center justify-content-center w-100 h-100">
            <p class="no-data-report">{{ 'IDMS.REPORTS.NO_DATA_TO_DISPLAY' | transloco }}</p>
        </div>
    </div>
    <div *ngIf="!SubscriptionList || SubscriptionList?.length === 0" class="d-flex align-items-center justify-content-center w-100 h-100">
        <p class="no-data-report">{{ 'IDMS.REPORTS.NO_DATA_TO_DISPLAY' | transloco }}</p>
    </div>
</div>
